import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <footer
      class="app-footer fixed bottom-0 left-0 right-0 z-10 box-border w-full border-t border-slate-200 bg-slate-50 px-4 py-3 shadow-[0_-2px_4px_rgba(0,0,0,0.05)] dark:border-slate-800 dark:bg-slate-950 dark:shadow-none"
    >
      <div class="mx-auto max-w-full text-center">
        <p class="m-0 text-xs leading-normal text-slate-500 dark:text-slate-400 md:text-xs">
          © {{ currentYear }} CartCo Tech Platforms India Pvt Ltd
        </p>
      </div>
    </footer>
  `,
  styles: [`
    :host {
      position: fixed;
      z-index: 10;
    }
  `]
})
export class AppFooterComponent {
  currentYear = new Date().getFullYear();
}

